import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './ui/SectionHeading';
import { modules } from '../data/modules';
import { totalVolumes } from '../data/offer';
export function ModulesSection() {
  return <section className="bg-navy-950 py-16 sm:py-20" aria-labelledby="modules-title" data-id="element-119" data-mp="1iwcxjc03p0fu">
      <div className="mx-auto max-w-6xl px-4" data-id="element-120" data-mp="1dxjhbbtfivbz">
        <SectionHeading id="modules-title" data-id="element-121" data-mp="1dunill9rc2mh">The {totalVolumes} <span className="text-copper" data-id="element-122" data-mp="2bj7fo29g3nq5">Complete Volumes</span></SectionHeading>

        <div className="mt-10 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-123" data-mp="26kme9zigiy04">
          {modules.map((module, index) => {
          const Icon = module.icon;
          return <motion.article key={module.title} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            amount: 0.15
          }} transition={{
            duration: 0.3,
            delay: index % 3 * 0.05,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col rounded-2xl border border-steel/70 bg-navy-900 p-6 shadow-lg shadow-black/30" data-id="element-124" data-mp="21o5ol0vm0bkx" data-mpi={index}>
                <div className="flex items-center gap-3" data-id="element-125" data-mp="1ntjyy39z9vk2">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl border border-copper/40 bg-navy-950 text-copper" data-id="element-126" data-mp="18xuewaocrshz">
                    <Icon className="h-5 w-5" aria-hidden="true" data-id="element-127" data-mp="1dy8ingix8ga7" />
                  </span>
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-gold" data-id="element-128" data-mp="102o22rqo0a5y">Volume {module.number}</p>
                </div>
                <h3 className="mt-4 text-xl font-extrabold uppercase leading-tight text-white" data-id="element-129" data-mp="q6tfxmn8fwyf">{module.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-steel-light" data-id="element-130" data-mp="v4uxu48x9q8b">{module.summary}</p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}